import request from "@/utils/request";
import Qs from "qs";

const api = {
  findByScreen: "/api/authentication/find-by-screen",
  delAuths: "/api/authentication/del-auths",
  save: "/api/authentication/save",
  findByRole: "/api/authentication/find-by-role",
  findByUserId: "/api/authentication/find-by-user"
};

export function findByScreen(parameter) {
  return request({
    url: api.findByScreen,
    method: "get",
    params: parameter
  });
}

export function delAuths(parameter) {
  return request({
    url: api.delAuths,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

export function save(parameter) {
  return request({
    url: api.save,
    method: "post",
    data: Qs.stringify(parameter)
  });
}

export function findByRole(parameter) {
  return request({
    url: api.findByRole,
    method: "get",
    params: parameter
  });
}

export function findByUserId(parameter) {
  return request({
    url: api.findByUserId,
    method: "get",
    params: parameter
  });
}
